import { render } from "./RecommendedQuestions.vue?vue&type=template&id=3b72776d&scoped=true"
import script from "./RecommendedQuestions.vue?vue&type=script&lang=js"
export * from "./RecommendedQuestions.vue?vue&type=script&lang=js"

import "./RecommendedQuestions.vue?vue&type=style&index=0&id=3b72776d&scoped=true&lang=scss"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b72776d"]])

export default __exports__